import { ArtistState } from "explorer/reducers/artistas";
import { useSelector } from "react-redux";
import "./ProfileProgressRing.scss";

interface ProfileProgressRingProps {
  size?: number;
}

const ProfileProgressRing: React.FC<ProfileProgressRingProps> = ({
  size = 100,
}) => {
  const { userArtist } = useSelector((state: ArtistState) => state.artists);
  const progress = userArtist.stagePercentual || 0;
  const center = size / 2;
  const radius = size * 0.4;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  const imageSize = size * 0.7;

  return (
    <div
      className="profile-progress-ring"
      style={{ position: "relative", width: size, height: size }}
    >
      <svg width={size} height={size} className="progress-ring">
        <circle
          r={radius}
          cx={center}
          cy={center}
          fill="transparent"
          stroke="#d2bfff"
          strokeWidth="3"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div
        className="background-image"
        style={{
          background: `
            linear-gradient(
            0deg,
            rgba(78, 72, 203, 0.50) 0%,
            rgba(78, 72, 203, 0.50) 100%
            ),
            url(${userArtist.profileImage}) center/cover no-repeat, #c4c4c4
          `,
          width: imageSize,
          height: imageSize,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `translate(-50%, -50%)`,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="progress-text">
          <div>{progress.toFixed(0)}%</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileProgressRing;
